
























































































































































































































import { Vue } from "../../constants/constants";
import {
ifItemSizeExist,
toFixedPrice,
counter
} from "../../helpers";
import {
genericErrorsEnum
} from "../../models/basket.model";
import { staticContent } from "../../localisation/detect-lang"
var modalOpened = false;

export default Vue.component("basket-item-modal", {
data() {
  return {
          staticContent
  };
},
props:{
  basketItemModal:null,
},
computed: {
  bindConditionalClasses(){
   return this.$root.bindConditionalClasses;
  },
  basketisGroup(){
    return this.$store.state.basketCompact.data.isGroup;
  },
  isGroupLocked(){
    return this.$store.state.basketCompact.data.isLocked;
  },
    flattenExtraCategoriesSizes(){
    let excatSizesArr=Object.values(this.basketItemModal.flatExtraCategories).reduce((acc,a)=>acc.concat(a.flatSizes), [] );
    return  Object.assign({},...excatSizesArr)
  },
  flattenSelectedItems(){
  return Object.values(this.basketItemModal.flatExtraCategories).reduce((acc,a)=>acc.concat(a.selectedItems), [] );
  },
  isItemAvailable(){
    const {availability}=this.basketItemModal.itemData;
    return availability.availableForDelivery && availability.availableInBranch && availability.availableInCurrentMenu && availability.timeAvailability.availableNow;
  }
},
methods: {
  isItemParentSelected(parentUUID){
      let excatSizes= this.flattenExtraCategoriesSizes;
let ISit=
this.flattenSelectedItems.some(
selectedItem=> 
parentUUID==excatSizes[selectedItem].itemUUID)

return ISit
  },
 hideModal(){
this.$root.modalToggler('basket-item-modal', 'hide')
 },
  removeItem(basketItemUUID) {
    var itemModalData={};
    itemModalData = Object.assign(itemModalData, this.itemModalData);
    if(navigator.onLine){
      let removeActionName= this.basketisGroup ? 'REMOVE_ITEM_FROM_GROUP_BASKET':'REMOVE_ITEM_FROM_BASKET';
      this.$store.dispatch(removeActionName, basketItemUUID)
      .catch((err)=>{
        let vue=this;
        this.$root.handleGroupError(err,function(){ 
          vue.$root.handleGenericErrors(
                genericErrorsEnum.item,
                "remove",
                itemModalData,
                null,
                basketItemUUID
              );
        });

      }
      
      
      );
    }else{
        this.$root.handleGenericErrors(
              genericErrorsEnum.internet,
              "remove",
              itemModalData,
              null,
              basketItemUUID
            );
    }
    this.hideModal();
  },
  removeAll() {
     if (navigator.onLine) {
      this.$store
        .dispatch("REMOVE_ALL_ITEMS_FROM_BASKET")
        .then(() => {
          this.$store.commit("updateBasketIsGroup",false);
          this.$root.groupSummaryInterval &&
            clearInterval(this.$root.groupSummaryInterval);
          this.$root.compactBasketInterval &&
            clearInterval(this.$root.compactBasketInterval);
        })
        .catch(() => {
          this.$root.handleGenericErrors(
            genericErrorsEnum.generic,
            "remove-all"
          );
        })
        .catch(() => {
          this.hasError = true;
        });
    } else {
      this.$root.handleGenericErrors(
        genericErrorsEnum.internet,
        "remove-all"
      );
    }
  },
  clearExtras(){
    for(let exCatUUID in this.basketItemModal.flatExtraCategories){
      this.basketItemModal.flatExtraCategories[exCatUUID].selectedItems = [];
    }
  },
  revalidateSelectedExtras(){
    this.basketItemModal.itemData.extraCategories.forEach(exCat =>{
     
      if(!(this.isItemParentSelected(exCat.parentUUID)||exCat.parentUUID== null || exCat.parentUUID==this.basketItemModal.itemData.itemUUID))
      {
      this.basketItemModal.flatExtraCategories[exCat.uuid].selectedItems = [];
      }
    })
  },
  collapseHandler(target) {
    this.$root.collapseHandler(target);
  },
  displayValidExtras(){
    this.$root.$nextTick(() => {
      $('#basket-item-modal').find('.extras-list.size-restricted-list').each(function(){
        let $this = $(this);
        let $parent = $this.closest(".item-extras");
        $this.children().length == 0
          ? $parent.addClass("hide")
          : $parent.removeClass("hide");
      });
    });
  },
  itemSizeChangeHandler() {
    this.clearExtras();
    this.calcItemSubTotal();
    this.displayValidExtras();
  },
 
  newCalcExtrasTotalPrice(itemExtras) {
    return this.$root.newCalcExtrasTotalPrice(itemExtras);
  },
 flatItemSizes (itemsObj)  {
    return this.$root.getFlatItemSizes(itemsObj);
  },
 
 
  quantityCounter(method) {
    this.basketItemModal.itemData.quantity = counter(
      method,
      this.basketItemModal.itemData.quantity
    );
  },
  editItem(updatedData) {
    var itemModalData={};
    itemModalData = Object.assign(itemModalData, updatedData);
    let actionName= this.basketisGroup ? 'EDIT_GROUP_BASKET_ITEM':'EDIT_BASKET_ITEM';
    this.$store.commit('editBasketItem', updatedData);
    if(navigator.onLine){
    this.$store.dispatch(actionName, updatedData.itemData.basketItemUUID)
    .catch((err) => {
      let vue=this;
      this.handleGroupError(err, function(){
        vue.$root.handleGenericErrors(genericErrorsEnum.item, 'edit', itemModalData);
      });
    })
    
    }
    else{
      this.$root.handleGenericErrors(genericErrorsEnum.internet, 'edit', itemModalData);
    }
    
    this.$root.modalToggler('basket-item-modal', 'hide')
  },
  calcItemSubTotal() {
    this.basketItemModal.isExCatsValid = true;
    this.revalidateSelectedExtras();
    const sizeQuantityPrice = toFixedPrice(
      this.basketItemModal.flatSizes[this.basketItemModal.itemData.selectedSizeUUID].price * this.basketItemModal.itemData.quantity
    );
    let extrasPrice = 0;
    let isExCatsValid = true;
    for (let exCatUUID in this.basketItemModal.flatExtraCategories) {
      let exCat = this.basketItemModal.flatExtraCategories[exCatUUID];

      if (exCat.sizeRestricted) {
        let sizes: any[] = [];
        for (let exSizeUUID in exCat.flatSizes) {
          let exSize = exCat.flatSizes[exSizeUUID];
          exSize.sizeUUID ==
            this.basketItemModal.flatSizes[this.basketItemModal.itemData.selectedSizeUUID].sizeUUID && sizes.push(exSize);
        }

        sizes.length &&
          !(exCat.minimumAllowedExtra <= exCat.selectedItems.length) &&
          (isExCatsValid = false);
      } else {
        !(exCat.minimumAllowedExtra <= exCat.selectedItems.length) &&
          (isExCatsValid = false);
      }

      extrasPrice += exCat.selectedItems.reduce(
        (sum, sizeUUID) => sum + exCat.flatSizes[sizeUUID].price,
        0
      );
    }
    
    let itemSubTotal = parseFloat(sizeQuantityPrice) + this.basketItemModal.itemData.quantity * extrasPrice;
    let itemModal = Object.assign({}, this.basketItemModal, {
      isExCatsValid,
      itemSubTotal
    });
    this.$store.commit('updateBasketItemModal',itemModal);      
  },
  toFixedPrice(price) {
    return this.$root.toFixedPrice(price);
  },
}
});
